module.exports = __webpack_public_path__ + "img/advanced-lessoner.52bc754e.png";